if (!customElements.get('product-details')) {
  customElements.define(
    'product-details',
    class ProductDetails extends HTMLElement {
      connectedCallback() {
        this.controllers = [];
        this.querySelectorAll('details').forEach((details) => {
          const summary = details.querySelector('summary');
          const controller = new AbortController();
          this.controllers.push(controller);
          let animation;
          let expanded = details.open;

          const reset = () => {
            animation?.cancel();
            animation = null;
            details.style.height = '';
            details.style.overflow = '';
          };

          summary.setAttribute('aria-expanded', expanded);
          summary.setAttribute('aria-controls', summary.nextElementSibling.id);
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const startHeight = details.getBoundingClientRect().height;
            reset();
            expanded = !expanded;
            summary.setAttribute('aria-expanded', expanded);

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
              details.open = expanded;
              return;
            }

            // Keep content rendered until the closing animation has finished.
            details.open = true;
            const endHeight = expanded ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
            details.style.height = `${startHeight}px`;
            details.style.overflow = 'hidden';
            animation = details.animate(
              [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
              { duration: 500, easing: 'cubic-bezier(0.4, 0, 0.4, 1)', fill: 'forwards' }
            );
            animation.onfinish = () => {
              details.open = expanded;
              reset();
            };
          }, { signal: controller.signal });

          details.addEventListener('toggle', () => {
            // Synchronize native changes, including Escape from the theme's global handler.
            if (!details.open) reset();
            if (!animation) {
              expanded = details.open;
              summary.setAttribute('aria-expanded', expanded);
            }
          }, { signal: controller.signal });
          controller.signal.addEventListener('abort', reset, { once: true });
        });
      }

      disconnectedCallback() {
        this.controllers.forEach((controller) => controller.abort());
      }
    }
  );
}
